module.exports = __webpack_public_path__ + "static/media/three_quarters_front_right_picture.21afa758.png";